import env from 'config/env'

const absolute = (path, host) =>
  path && (/^(https?:)?\/\//.test(path) ? path : `${host}${path}`)

// Keep the CMS sequence, including inline clips and the separate legacy video.
export const galleryMedia = (images = [], video = {}) => {
  const media = (images || []).filter(Boolean).map((image, index) => ({
    key: `${image.full_path || image.path || ''}-${index}`,
    poster: image.full_path || absolute(image.path, env.IMG_HOST),
    src: image.full_video_path || null,
    imageType:
      image.image_type || (image.full_video_path ? 'video' : 'product'),
    autoPlay: !!image.full_video_path,
  }))
  if (video?.video_path) {
    media.push({
      key: `video-${video.video_path}`,
      poster:
        video.full_cover_image_path ||
        absolute(video.cover_image_path, env.IMG_HOST),
      src: absolute(video.video_path, env.MEDIA_CLOUDFRONT_URL),
      imageType: video.image_type || 'video',
      autoPlay: false,
    })
  }
  return media.filter((item) => item.poster || item.src)
}

export const clampIndex = (index, count) =>
  Math.max(0, Math.min(count - 1, index))
